import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import style from '@/styles/components/file-dnd/FileUpload.module.css';
import ConfirmationModal from 'components/ConfirmationModal';

interface FileUploadProps {
  onFileUpload: (file: File) => void;
  selectedFile: File | null;
}

const FileUpload: React.FC<FileUploadProps> = ({
  onFileUpload,
  selectedFile,
}) => {
  const [fileSize, setFileSize] = useState(false);
  const [fileType, setFileType] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles: File[], rejectedFiles: any) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        onFileUpload(file);
      }

      if (rejectedFiles.length > 0) {
        const err = rejectedFiles[0].errors[0].code;
        if (err === 'file-invalid-type') {
          setFileType(true);
        }

        if (err === 'file-too-large') {
          setFileSize(true);
        }
      }
    },
    [onFileUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': [],
      'image/jpg': [],
      'image/png': [],
      'image/webp': [],
    },
    maxSize: 1024 * 1024 * 5,
  });

  const dragActive = isDragActive ? style.DragActive : '';

  return (
    <>
      {!selectedFile && (
        <div {...getRootProps()} className={`${style.DropZone} ${dragActive}`}>
          {fileType && (
            <ConfirmationModal
              text="invalid file type"
              onClose={() => setFileType(false)}
            />
          )}
          {fileSize && (
            <ConfirmationModal
              text="File size larger that allowed"
              onClose={() => setFileSize(false)}
            />
          )}
          <input {...getInputProps()} />
          {isDragActive ? (
            <p className={style.PlaceholderText}>Drop the file here...</p>
          ) : (
            <div className={style.PlaceholderText}>
              <p>
                Drop an image file here, or &nbsp;
                <span className={style.Browse}>Browse</span>
              </p>
              <div className={style.PlaceholderSubText}>
                <p>Only jpeg/png files allowed</p>
                <p>File size should be less than 5mb</p>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FileUpload;
